import { Component, Input } from '@angular/core'

import { environment } from '../../../../../environments/environment'
import { CommonModule } from '@angular/common'
import { ImageComponent } from '../../partials/image/image.component'

@Component({
    selector: 'case-image-yield',
    templateUrl: './image-yield.component.html',
    styleUrls: ['./image-yield.component.scss'],
    standalone: true,
    imports: [CommonModule, ImageComponent]
})
export class ImageYieldComponent {
  @Input() image: string
  @Input() defaultImage = '/assets/images/avatar.svg'
  @Input() label: string

  storagePath: string = environment.storagePath
}
